var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delete-account" },
    [
      _vm.showDeleteAccountButton
        ? _c("ui-button", {
            attrs: {
              type: "button",
              "button-type": "blank",
              size: "small",
              label: _vm.i18n.deleteAccount,
              "normal-case": "",
            },
            on: { click: _vm.onDelete },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon-left",
                  fn: function () {
                    return [_c("svg-trash-icon")]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2558307104
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showSendingEmailTextSection
        ? _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("span", { staticClass: "mr-3" }, [
                _vm._v("\n      " + _vm._s(_vm.i18n.sendingEmail) + "\n    "),
              ]),
              _vm._v(" "),
              _c("spinner", { attrs: { width: "20", height: "20" } }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailSentTextSection
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-content-between max-w-360-px",
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "p",
                  { staticClass: "text-gray-800 text-sm font-weight-semibold" },
                  [
                    _c("svg-success", { attrs: { color: "green" } }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.i18n.emailSent) + "\n      "
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "text-gray-800 text-sm font-weight-normal",
                attrs: { id: "delete-account__sent-confirmation-email-text" },
                domProps: {
                  innerHTML: _vm._s(_vm.i18n.sentConfirmationEmailText),
                },
              }),
              _vm._v(" "),
              _vm.showResendLinkText
                ? _c(
                    "p",
                    {
                      staticClass: "text-gray-800 text-sm font-weight-semibold",
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.i18n.didNotReceiveEmailText) +
                          "\n      "
                      ),
                      _c("ui-button", {
                        staticClass: "px-0",
                        attrs: {
                          type: "button",
                          "button-type": "blank",
                          size: "small",
                          "font-weight": "semibold",
                          label: _vm.i18n.sendNewLinkText,
                          "normal-case": "",
                        },
                        on: { click: _vm.resendLink },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFailDeliverySection
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column justify-content-between max-w-360-px",
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "p",
                  { staticClass: "text-gray-800 text-sm font-weight-semibold" },
                  [
                    _c("svg-error"),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.i18n.emailDeliveryFailedTitle) +
                        "\n      "
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-gray-800 text-sm font-weight-normal",
                domProps: {
                  innerHTML: _vm._s(_vm.i18n.emailDeliveryFailedMessage),
                },
              }),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-gray-800 text-sm font-weight-normal",
                domProps: { textContent: _vm._s(_vm.i18n.contactSupport) },
              }),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "text-gray-800 text-sm font-weight-semibold" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.i18n.didNotReceiveEmailText) +
                      "\n\n      "
                  ),
                  _c("ui-button", {
                    staticClass: "px-0",
                    attrs: {
                      type: "button",
                      "button-type": "blank",
                      size: "small",
                      "font-weight": "semibold",
                      label: _vm.i18n.resendLinkText,
                      "normal-case": "",
                    },
                    on: { click: _vm.resendLink },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }